import { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';

import ChatIcon from 'components/icons/ChatIcon';
import ReactSpeechKit from 'components/ReactSpeechKit';
import { VirtualMC } from 'components/VirtualMC';
import ChatbotAvt from './chatbot.png';
import MC from './mc_img.png';

import './styles.scss';
import Spinner from 'components/Spinner';

const ChatBot = ({ onChangeScene, currentPano }) => {
  const scenes = window.data.json.scenes;
  const { isCallBot } = useSelector((state) => state);
  const [isOpenAssistant, setIsOpenAssistant] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([
    {
      sender: 'bot',
      text: "Hello, I'm your ChatBot Success Software assistant!",
    },
  ]);
  const [isTyping, setIsTyping] = useState(false);
  const [showOptions, setShowOptions] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false); // 👈 NEW
  const [audioUrl, setAudioUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const audioRef = useRef(null);
  const chatEndRef = useRef(null);
  const wsRef = useRef(null);

  const sessionId = window.sessionId;
  const wsUrl = `wss://socket-io-tour-success-chatbot.vizion.space/ws/${sessionId}`;

  useEffect(() => {
    const socket = new WebSocket(wsUrl);
    socket.onopen = () => {
      console.log('WebSocket connection opened');
    };

    socket.onmessage = async (event) => {
      if (event.data) {
        const data = JSON.parse(event.data);
        console.log('🚀 ~ socket.onmessage= ~ data:', data);
        setAudioUrl(data.audio_url);
        setMessages((prev) => [...prev, { sender: 'bot', text: data.message }]);
        setIsTyping(false);

        if (isCallBot) {
          setIsLoading(false);
          playAudio(data.audio_url);
          setIsPlaying(true);
        }

        const scene = scenes.find((s) => Object.values(s).includes(data.id));
        if (scene) onChangeScene(scene.groupId, scene.id);
      }
    };

    socket.onclose = () => {
      console.log('WebSocket connection closed');
    };

    wsRef.current = socket;
    return () => socket.close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChangeScene, isCallBot]);

  const playAudio = (url) => {
    if (audioRef.current) {
      audioRef.current.src = url;
      audioRef.current.play();
    }
  };

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handlePlay = () => setIsAudioPlaying(true);
    const handleEnded = () => {
      setIsAudioPlaying(false);
      setIsPlaying(false);
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        wsRef.current.send(
          JSON.stringify({
            type: 'delete_audio',
            audio_url: audio.src,
          })
        );
        console.log('🗑️ Đã gửi yêu cầu delete_audio:', audio.src);
      }
    };

    audio.addEventListener('play', handlePlay);
    audio.addEventListener('ended', handleEnded);

    return () => {
      audio.removeEventListener('play', handlePlay);
      audio.removeEventListener('ended', handleEnded);
    };
  }, []);

  const onClickChat = useCallback(() => {
    setIsOpen(true);
    setAudioUrl('');
  }, []);

  const sendToWebSocket = (message) => {
    console.log('🚀 ~ sendToWebSocket ~ message:', message);
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      const payload = { message };
      wsRef.current.send(JSON.stringify(payload));
    } else {
      console.error('WebSocket chưa kết nối!');
    }
  };

  const sendMessage = useCallback(
    (event) => {
      event.preventDefault();
      if (message.trim() === '') return;
      const newMessages = [...messages, { sender: 'user', text: message }];
      setMessages(newMessages);
      setIsTyping(true);
      setMessage('');

      sendToWebSocket(message);
    },
    [message, messages]
  );

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div
      className="chat-container"
      style={{ bottom: '0px', right: '50px', width: '250px' }}
    >
      {isOpenAssistant && (
        <Fragment>
          {/* Chat icon + ReactSpeechKit */}
          {!isOpen && (
            <div className="chat-button-container">
              <button
                className="chat-button"
                onClick={() => setShowOptions(!showOptions)}
              >
                {isLoading && <Spinner />}
                <img
                  src={MC}
                  alt="Bot"
                  className="bot-icon"
                  style={{ opacity: `${isLoading ? '0.5' : '1'}` }}
                />
              </button>
              <div
                className="chat-options"
                style={{
                  opacity: showOptions ? '1' : '0',
                  pointerEvents: showOptions ? 'auto' : 'none',
                }}
              >
                <button onClick={onClickChat} disabled={isCallBot}>
                  <ChatIcon />
                </button>
                <ReactSpeechKit
                  sendToWebSocket={(msg) =>
                    wsRef.current.send(JSON.stringify({ message: msg }))
                  }
                  isAudioPlaying={isAudioPlaying} // 👈 truyền xuống
                  setIsLoading={() => setIsLoading(true)}
                />
              </div>
            </div>
          )}

          {/* Chat UI */}
          {isOpen && (
            <div className="chat-box" style={{ width: isMobile ? 300 : 384 }}>
              <div className="chat-header">
                <div className="chat-header-left">
                  <img src={ChatbotAvt} alt="Bot" className="bot-icon" />
                  <h2>Success Software assistant</h2>
                </div>
                <button className="close-btn" onClick={() => setIsOpen(false)}>
                  ✖
                </button>
              </div>

              <div
                className="chat-body"
                style={{ height: isMobile ? 300 : 400 }}
              >
                {messages.map((msg, index) => (
                  <div key={index} className={`message ${msg.sender}`}>
                    {msg.sender === 'bot' && (
                      <img src={ChatbotAvt} alt="Bot" className="bot-icon" />
                    )}
                    <p
                      dangerouslySetInnerHTML={{
                        __html: msg.text
                          .replace(/\n/g, '<br />')
                          .replace(/\*\*(.*?)\*\*/g, '<b>$1</b>'),
                      }}
                    />
                  </div>
                ))}
                {isTyping && (
                  <div className="message bot typing">
                    <img src={ChatbotAvt} alt="Bot" className="bot-icon" />
                    <p>
                      <span></span>
                      <span></span>
                      <span></span>
                    </p>
                  </div>
                )}
                <div ref={chatEndRef} />
              </div>

              <div className="chat-footer">
                <input
                  type="text"
                  value={message}
                  placeholder="Send a message..."
                  onChange={(e) => setMessage(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && sendMessage(e)}
                />
                <button className="send-button" onClick={sendMessage}>
                  Send
                </button>
              </div>
            </div>
          )}
          {audioUrl && (
            <VirtualMC
              isPlaying={isPlaying}
              audioRef={audioRef}
              isLoading={isLoading}
            />
          )}
          <audio ref={audioRef} preload="auto" />
        </Fragment>
      )}
      {!isOpen && (
        <button
          className="close_assistant"
          onClick={() => setIsOpenAssistant(!isOpenAssistant)}
        >
          <img src={ChatbotAvt} alt="chatbot" />
        </button>
      )}
    </div>
  );
};

export default ChatBot;
